import { render, staticRenderFns } from "./AutoView.vue?vue&type=template&id=463e682b&scoped=true&"
import script from "./AutoView.vue?vue&type=script&lang=ts&"
export * from "./AutoView.vue?vue&type=script&lang=ts&"
import style0 from "./AutoView.vue?vue&type=style&index=0&id=463e682b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "463e682b",
  null
  
)

export default component.exports